import { useEffect, useState } from 'react';
import { Button, DropdownButton } from '@habitech/call-to-action';
import { GridItem } from 'src/components/common/grids';
import { Title, SearchWrapper, Description } from './styles';
import { createHabiStackLeads, listHabiLeadsStacks } from 'src/redux/habi_leads/thunks';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';

import Table from '../common/tables';
import { TableRow } from '../common/tables/TableRow';
import { TableCell } from '../common/tables/TableCell';
import { TableHeader } from '../common/tables/TableHeader';
import { HEADERS as OptionsCount } from './constants';

export const HabiLeadsSellers = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState<number>();
    const logs = useAppSelector(({ HabiLeads }) => HabiLeads.list);

    const handleSearch = () => {
        if (count) {
            setLoading(true);
            dispatch<any>(createHabiStackLeads(count))
                .unwrap()
                .then(() => {
                    dispatch<any>(listHabiLeadsStacks());
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        } else {
            alert('Seleccione una cantidad de leads para calificar');
        }
    };

    useEffect(() => {
        dispatch<any>(listHabiLeadsStacks());
    }, [dispatch]);
    return (
        <div>
            <Title>Peticiones calificación leads sellers TuHabi</Title>
            <Description>
                Al solicitar la calificación leads Habi, llevaremos a cabo una búsqueda en nuestra base de datos para identificar las propiedades, más
                recientes, que cumplen con los criterios necesarios para considerarse como leads calificados Habi. Estas propiedades se almacenarán en
                nuestra base de datos con el estado 7, que significa "Leads calificado bajo petición del administrador". Posteriormente, en un proceso
                asincrónico, estas propiedades serán revisadas al final del día para validar la ubicación y el precio, y una vez validados, se
                enviarán a Habi como leads calificados.
            </Description>
            <SearchWrapper>
                <GridItem sm={4} md={6} lg={8}>
                    <DropdownButton
                        dataId="search-url"
                        label="Cantidad de leads"
                        originType="pcom"
                        variant="white"
                        placeholder="Selecciona la cantidad de leads"
                        size="fluid medium"
                        listOptions={OptionsCount}
                        setValue={(value) => setCount(Number(value))}
                        error={Boolean(false)}
                        errorMessage={''}
                    />
                </GridItem>
                <GridItem sm={2} md={2} lg={2}>
                    <Button dataId="button-search" originType="pcom" size="large" fluid onClick={handleSearch} loading={loading} disabled={loading}>
                        Calificar
                    </Button>
                </GridItem>
            </SearchWrapper>
            <p>Ultimas 20 solicitudes</p>
            <Table>
                <thead>
                    {['Administrador', 'Total disponibles', 'Total solicitados', 'Fecha de solicitud'].map((item) => (
                        <TableHeader key={item}>{item}</TableHeader>
                    ))}
                </thead>
                <tbody>
                    {logs?.map(({ created, name, total_available, total_leads }) => (
                        <TableRow key={`row-codes-${created}`}>
                            <TableCell>{name}</TableCell>
                            <TableCell>{total_available}</TableCell>
                            <TableCell>{total_leads}</TableCell>
                            <TableCell>{created}</TableCell>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};
